import { c as _c } from "react/compiler-runtime";
import type { IdDocImageTypes } from '@onefootprint/types';
import type { ComponentProps } from 'react';
import { NavigationHeader } from '@/idv/components';
import DesktopPhotoPrompt from '../../../components/desktop-photo-prompt';
import type { IdDocImageUploadError } from '../../../types';
import useDocName from '../../hooks/use-doc-name';
import useIdDocMachine from '../../hooks/use-id-doc-machine';
type DesktopCaptureProps = {
  imageType: `${IdDocImageTypes}`;
  isRetry?: boolean;
  onBack?: () => void;
  onComplete: ComponentProps<typeof DesktopPhotoPrompt>['onUploadSuccess'];
};
const DesktopCapture = t0 => {
  const $ = _c(24);
  const {
    imageType,
    isRetry: t1,
    onBack,
    onComplete
  } = t0;
  const isRetry = t1 === undefined ? false : t1;
  const [state, send] = useIdDocMachine();
  const {
    errors,
    hasBadConnectivity,
    idDoc,
    allowPdf
  } = state.context;
  const docType = idDoc.type;
  const countryCode = idDoc.country;
  let t2;
  if ($[0] !== docType || $[1] !== imageType) {
    t2 = {
      docType,
      imageType
    };
    $[0] = docType;
    $[1] = imageType;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    getDocName,
    getSideName
  } = useDocName(t2);
  if (!docType || !countryCode) {
    return null;
  }
  let t3;
  if ($[3] !== send) {
    t3 = errs => {
      send({
        type: "uploadErrored",
        payload: {
          errors: errs.map(_temp)
        }
      });
    };
    $[3] = send;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleUploadError = t3;
  let t4;
  if ($[5] !== onBack) {
    t4 = <NavigationHeader leftButton={{
      variant: "back",
      onBack
    }} />;
    $[5] = onBack;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== getDocName) {
    t5 = getDocName();
    $[7] = getDocName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== getSideName) {
    t6 = getSideName();
    $[9] = getSideName;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== allowPdf || $[12] !== countryCode || $[13] !== errors || $[14] !== handleUploadError || $[15] !== hasBadConnectivity || $[16] !== isRetry || $[17] !== onComplete || $[18] !== t5 || $[19] !== t6) {
    t7 = <DesktopPhotoPrompt country={countryCode} docName={t5} errors={errors} hasBadConnectivity={hasBadConnectivity} isRetry={isRetry} onUploadError={handleUploadError} onUploadSuccess={onComplete} allowPdf={allowPdf} sideName={t6} />;
    $[11] = allowPdf;
    $[12] = countryCode;
    $[13] = errors;
    $[14] = handleUploadError;
    $[15] = hasBadConnectivity;
    $[16] = isRetry;
    $[17] = onComplete;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t4 || $[22] !== t7) {
    t8 = <>{t4}{t7}</>;
    $[21] = t4;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default DesktopCapture;
function _temp(err) {
  return {
    errorType: err
  };
}